import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import classNames from 'classnames';

const SelectListItemTag = ({ align = 'right', className, children, ...rest })=>{
    const tagClasses = useMemo(()=>{
        return classNames({
            [`align-${align ?? ''}`]: align
        }, 'cb-select-list-item-tag', className);
    }, [
        align,
        className
    ]);
    if (children == null) return null;
    return jsx("span", {
        className: tagClasses,
        ...rest,
        children: jsx("span", {
            children: children
        })
    });
};
SelectListItemTag.displayName = 'SelectList.Item.Tag';

export { SelectListItemTag };
//# sourceMappingURL=SelectListItem.Tag.es.js.map
